module.exports = __webpack_public_path__ + "img/3PILOT.3efa66cd.jpg";